import { DropdownOptionProps } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import { CreditTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { MealCreditLength } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export const oneTimeOptions: DropdownOptionProps[] = [
  { value: MealCreditLength.DAILY, text: 'Day' },
  { value: MealCreditLength.WEEKLY, text: 'Week' },
  { value: MealCreditLength.MONTHLY, text: 'Month' },
  { value: MealCreditLength.CUSTOM, text: 'Custom' },
];

export const recurringOptions: DropdownOptionProps[] = [
  { value: MealCreditLength.DAILY, text: 'Daily' },
  { value: MealCreditLength.WEEKLY, text: 'Weekly' },
  { value: MealCreditLength.MONTHLY, text: 'Monthly' },
  { value: MealCreditLength.CUSTOM, text: 'Custom' },
];

export const getFrequencyPeriodLabel = (
  frequency: CreditTypeValues
): string => {
  switch (frequency) {
    case CreditTypeValues.REPEATS:
      return 'Refresh frequency';
    case CreditTypeValues.SINGLE:
    default:
      return 'Time period';
  }
};

export const getFrequencyPeriodOptions = (
  frequency: CreditTypeValues
): DropdownOptionProps[] => {
  switch (frequency) {
    case CreditTypeValues.REPEATS:
      return recurringOptions;
    case CreditTypeValues.SINGLE:
    default:
      return oneTimeOptions;
  }
};
